export const INVENTORY_DATA = [
    {
        itemNumber: '0092038',
        itemName:
            'Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height, 32x23mm Footprint',
        isTissue: 'true',
        usedQty: '0',
        onHand: '3',
        lotSerial: '1276387',
        useBy: '09/18/2021',
    },
    {
        itemNumber: '0123123',
        itemName:
            'Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height',
        isTissue: 'true',
        usedQty: '4',
        onHand: '3',
        lotSerial: '1276387',
        useBy: '07/18/2021',
    },
    {
        itemNumber: '0232311',
        itemName:
            'Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height, 32x23mm Footprint Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height, 32x23mm Footprint',
        isTissue: 'true',
        usedQty: '1',
        onHand: '2',
        lotSerial: '1276387',
        useBy: '12/01/2021',
    },
    {
        itemNumber: '012345678',
        itemName:
            'Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height',
        isTissue: 'true',
        usedQty: '0',
        onHand: '2',
        lotSerial: '1276387',
        useBy: '09/18/2021',
    },
    {
        itemNumber: '087654321',
        itemName:
            'Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height',
        isTissue: 'true',
        usedQty: '0',
        onHand: '5',
        lotSerial: '1276387',
        useBy: '09/18/2021',
    },
    {
        itemNumber: '007895432',
        itemName:
            'Sovereign Small Implant Set - 8 & 12 Lordosis, 10-20mm Height',
        isTissue: 'true',
        usedQty: '0',
        onHand: '4',
        lotSerial: '1276387',
        useBy: '09/18/2021',
    },
];
export const CFN = 'cfn';
